import teaserControl from "./teaserControl";

document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.startseite')) {
        teaserControl({ignore: document.querySelector('.main-article-description h3').textContent});
    }
})